const translations = {
    complete: 'Completed'
};

export default translations;
